import React from 'react';

import './LoadingSpinner.css';

const LoadingSpinner = props => {
  return (
    <div className={`${props.asOverlay && 'loading-spinner__overlay'}`}>
      <div>
      {props.video && <video src={props.video} alt='uploaded video' controls className='video'/>}
      <div className='loading-box'>
      <div className="lds-dual-ring"></div>
      {props.pleaseWait && <div><p>Processing your video might take more than a minute. Please wait...</p></div>}
      </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
